module.exports = __webpack_public_path__ + "static/media/ye.68c39799.svg";